export class GroupBreakdownEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "compliant",
            "baseName": "compliant",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failing",
            "baseName": "failing",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return GroupBreakdownEntry.attributeTypeMap;
    }
    constructor() {
    }
}
